import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './components/ResetPassword'
import VerifyMFA from './components/VerifyMFA';

function App() {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // On initial load, check /verify so we know if the user is already logged in
    fetch('/api/verify', { credentials: 'include' })
      .then(res => {
        if (!res.ok) throw new Error('Not authenticated');
        return res.json();
      })
      .then(data => {
        setRole(data.role);
      })
      .catch(() => {
        setRole(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <Routes>
      {/* Unprotected route: Login page */}
      <Route path="/" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-mfa" element={<VerifyMFA />} />

      {/* /home route - if logged in as ADMIN, immediately redirect to /admin otherwise show <Home /> behind a ProtectedRoute */}
      <Route
        path="/home"
        element={
          (role === 'ADMIN' || role === 'SUPERADMIN') ? (
            <Navigate to="/admin" replace />
          ) : (
            <ProtectedRoute>
              <Home/>
            </ProtectedRoute>
          )
        }
      />

      {/* /admin route - only show <AdminDashboard /> if role === 'ADMIN'. */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredRole={['ADMIN','SUPERADMIN']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
